export default __webpack_public_path__ + "static/media/project3.6a64113d.jpg";